module.exports = __webpack_public_path__ + "static/media/storage_get_open_tips.f232a91.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/FreshCabinet/mp3/storage_get_open_tips.mp3
// module id = DzXf
// module chunks = 1